var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg011LogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 540 540",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.9,448.2c-.7-1.7-.9-3.2-.7-4.4.2-1.2-.5-2.2-2.3-2.9s-2.6-1.4-2.6-1.8-1.3-.8-3.8-1c-2.5-.2-3.8-.3-3.8-.3h-102.1c-14.4,0-26.7-5.1-37-15.4-10.3-10.3-15.4-22.6-15.4-37v-230.3c0-14.4,5.1-26.7,15.4-37,10.3-10.3,22.6-15.4,37-15.4h104.7c2.8,0,5.1-.7,6.7-2.1,1.6-1.4,2.7-3.5,3.3-6.4.5-2.8.9-5.4,1-7.7.1-2.3,0-5.2-.2-8.7-.2-3.5-.3-5.7-.3-6.5,0-2.8-1-5.3-3.1-7.4-2.1-2.1-4.5-3.1-7.4-3.1h-104.7c-26,0-48.1,9.2-66.6,27.6-18.4,18.4-27.6,40.6-27.6,66.6v230.3c0,26,9.2,48.1,27.6,66.6,18.4,18.4,40.6,27.7,66.6,27.7h104.7c2.8,0,5.1-.7,6.7-2.1,1.6-1.4,2.7-3.5,3.3-6.4.5-2.8.9-5.4,1-7.7.1-2.3,0-5.2-.2-8.7-.2-3.5-.3-5.7-.3-6.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M520.3,255.5l-178-178c-4.1-4.1-9.1-6.2-14.7-6.2s-10.6,2.1-14.7,6.2c-4.1,4.1-6.2,9.1-6.2,14.7v94.2h-146.6c-5.7,0-10.6,2.1-14.7,6.2-4.1,4.1-6.2,9.1-6.2,14.7v125.6c0,5.7,2.1,10.6,6.2,14.7,4.1,4.1,9.1,6.2,14.7,6.2h146.6v94.2c0,5.7,2.1,10.6,6.2,14.7,4.1,4.1,9.1,6.2,14.7,6.2s10.6-2.1,14.7-6.2l178-178c4.1-4.1,6.2-9.1,6.2-14.7,0-5.7-2.1-10.6-6.2-14.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg011LogOut);
export default __webpack_public_path__ + "static/media/011-log-out.ffe721a52cc7ee593cf555303996fb3a.svg";
export { ForwardRef as ReactComponent };